import styled from "styled-components";
import { RecordParticipationTypes, RemoveFeature } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useIsUKUser } from "src/shared/utils/appContextHelper";
import { TrendingEventsInLocale } from "src/website-apps/shared/components/trending-events-locale-carousel-grid";
import { useEventsGridContext } from "src/website-apps/shared/context/events-grid-context";

const StyledTrendingEventsInLocale = styled(TrendingEventsInLocale)`
  margin-top: ${(props) => props.theme.spacing(8)};
  padding: 0;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-top: ${(props) => props.theme.spacing(10)};
    padding: 0;
  }
`;

/**
 * Trending Events in Locale Experiment Component Wrapper
 */
export const TrendingEventsInSearch = ({ hasNoResults }) => {
  const [state] = useEventsGridContext();
  const { dates, location } = state.filters || {};
  const isUKUser = useIsUKUser();

  return hasNoResults ? (
    <RemoveFeature
      id={FeatureSetEnum.TMGlobalUKRemovePopularArtistsTrendingCity}
      canParticipate={() => isUKUser}
      recordType={RecordParticipationTypes.RENDER}
      feature={() => <StyledTrendingEventsInLocale categoryId={0} dates={dates} userLocation={location} />}
    />
  ) : null;
};
